import { PrioritySticker } from '@/src/components/priority/priority-sticker/PrioritySticker'
import { FamilyDto } from '@/infra/api/generated/model'

type FamilyCardHeaderProps = {
  family: FamilyDto
}

export const FamilyCardHeader = ({ family }: FamilyCardHeaderProps) => {
  return (
    <div className="flex justify-between text-sm">
      <p className="font-semibold">
        {family.id} - {family.name}
      </p>
      {family.isPriority && <PrioritySticker />}
    </div>
  )
}
